import { useContext } from 'react'
import { SsrContext } from '../contexts/SsrContext'

export const useSsrContext = () => {
  return useContext(SsrContext)
}
